export default __webpack_public_path__ + "static/media/game-guide-mobile.dd382cec.jpg";